import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vendor-confirmation',
  templateUrl: './vendor-confirmation.component.html',
  styleUrls: ['./vendor-confirmation.component.scss']
})
export class VendorConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
